<template>
    <div class="row">
        <div :class="selectedRow || selected4Warehouse || selectedWarehouse ? 'col-lg-9' : 'col-lg-12'">
            <div class="card stretch stretch-full">
                <div class="card-header">
                    <h5 class="card-title">İlaç Listesi</h5>
                    <div class="card-header-action">
                        <div class="card-header-btn">
                            <div data-bs-toggle="tooltip" title="Yenile">
                                <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                    data-bs-toggle="refresh"> </button>
                            </div>
                            <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                                <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                    data-bs-toggle="expand"> </a>
                            </div>
                        </div>
                        <div class="dropdown">
                            <a href="javascript:void(0);" class="avatar-text avatar-sm" data-bs-toggle="dropdown"
                                data-bs-offset="25, 25">
                                <div data-bs-toggle="tooltip" title="Seçenekler">
                                    <i class="feather-more-vertical"></i>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">
                                <router-link to="/medicine/add" class="dropdown-item"><i
                                        class="feather-plus-circle"></i>Yeni
                                    Ekle</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body custom-card-action p-0">
                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Adı</th>
                                    <th scope="col">Barkod</th>
                                    <th scope="col">Etken Madde</th>
                                    <th scope="col">Stok Bakiyesi</th>
                                    <th scope="col" class="text-end">İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="medicine in medicines" :key="medicine.id"
                                    :class="{ 'table-active': (selectedRow && medicine.id === selectedRow.id) || (selected4Warehouse && medicine.id === selected4Warehouse.id) || (selectedWarehouse && selectedWarehouse.medicine_id === medicine.id) }">
                                    <td>
                                        <div>
                                            <router-link :to="{ name: 'MedicineEdit', params: { id: medicine.id } }"
                                                class="d-block mb-1">{{ medicine.name }}</router-link>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            {{ medicine.barcode }}
                                        </div>
                                    </td>
                                    <td>{{ medicine.active_ingredient }}</td>
                                    <td>{{ medicine.stock_balance }}</td>
                                    <td>
                                        <div class="hstack gap-2 justify-content-end">
                                            <a @click="select4Warehouse(medicine)"
                                                title="Depolardaki İlaç Bakiyeleri Görüntüle"
                                                class="avatar-text avatar-md bg-blue text-white">
                                                <i class="feather-database fs-16"></i>
                                            </a>
                                            <a @click="selectRow(medicine)"
                                                title="Son Kullanma Tarihine Göre Bakiyeleri Görüntüle"
                                                class=" avatar-text avatar-md bg-blue text-white">
                                                <i class="feather-list fs-16"></i>
                                            </a>
                                            <router-link :to="{ name: 'MedicineEdit', params: { id: medicine.id } }"
                                                class="avatar-text avatar-md bg-orange">
                                                <i class="feather-eye fs-16"></i>
                                            </router-link>
                                            <a href="#" @click="deleteMedicine(medicine.id)"
                                                class="avatar-text avatar-md bg-red">
                                                <i class="feather-delete fs-16"></i>
                                            </a>

                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <Pagination :currentPage="currentPage" :totalPages="totalPages" :next="next" :previous="previous"
                        @page-changed="fetchData" />
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="row">
                <div class="col-lg-12" v-if="selectedRow">
                    <div class="card stretch stretch-full">
                        <div class="card-header">
                            <h5 class="card-title"><span class="text-danger">[{{ selectedRow.name }}]</span><br>
                                SKT Bazlı Liste</h5>
                            <div class="card-header-action">
                                <div class="card-header-btn">
                                    <div data-bs-toggle="tooltip" title="Kapat">
                                        <button @click="selectedRow = null" class="avatar-text avatar-xs bg-danger">
                                        </button>
                                    </div>

                                    <div data-bs-toggle="tooltip" title="Yenile">
                                        <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                            data-bs-toggle="refresh"> </button>
                                    </div>
                                    <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                                        <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                            data-bs-toggle="expand"> </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body custom-card-action p-0">
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Son Kullanma Tarihi</th>
                                            <th scope="col" class="text-end">Bakiyesi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="medicineByExpirationDate in medicinesByExpirationDate"
                                            :key="medicineByExpirationDate.medicine_id">
                                            <td>
                                                {{ medicineByExpirationDate.expiration_date }}
                                            </td>
                                            <td class="text-end">{{ medicineByExpirationDate.balance }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" v-if="selected4Warehouse">
                    <div class="card stretch stretch-full">
                        <div class="card-header">
                            <h5 class="card-title"><span class="text-danger">[{{ selected4Warehouse.name }}]</span><br>
                                Depolardaki Bakiyeler</h5>
                            <div class="card-header-action">
                                <div class="card-header-btn">
                                    <div data-bs-toggle="tooltip" title="Kapat">
                                        <button @click="selected4Warehouse = null"
                                            class="avatar-text avatar-xs bg-danger">
                                        </button>
                                    </div>

                                    <div data-bs-toggle="tooltip" title="Yenile">
                                        <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                            data-bs-toggle="refresh"> </button>
                                    </div>
                                    <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                                        <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                            data-bs-toggle="expand"> </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body custom-card-action p-0">
                            <div class="table-responsive">
                                <table class="table table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Depo Adı</th>
                                            <th scope="col" class="text-end">Bakiyesi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="medicineByWarehouse in medicinesByWarehouse"
                                            :key="medicineByWarehouse.medicine_id"
                                            @click="selectedWarehouse = medicineByWarehouse"
                                            :style="{ 'cursor': !selectedWarehouse || selectedWarehouse.warehouse_id != medicineByWarehouse.warehouse_id ? 'pointer' : 'default' }"
                                            :class="{ 'table-active': selectedWarehouse && selectedWarehouse.warehouse_id == medicineByWarehouse.warehouse_id }">

                                            <td>
                                                {{ medicineByWarehouse.warehouse_name }}
                                            </td>
                                            <td class="text-end">{{ medicineByWarehouse.quantity }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" v-if="selectedWarehouse">
                    <WarehouseStockListByExpirationDate v-if="selectedWarehouse" @close-card="selectedWarehouse = null"
                        :warehouseId="selectedWarehouse.warehouse_id" :medicineId="selectedWarehouse.medicine_id" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import Pagination from '@/components/common/Pagination.vue';
import WarehouseStockListByExpirationDate from '@/components/medicine/WarehouseStockListByExpirationDate.vue';

export default {
    name: 'MedicineTable',
    components: {
        Pagination,
        WarehouseStockListByExpirationDate,
    },
    data() {
        return {
            medicines: [],
            medicinesByExpirationDate: [],
            medicinesByWarehouse: [],
            currentPage: 1,
            totalPages: 1,
            next: true,
            previous: false,
            selectedRow: null,
            selected4Warehouse: null,
            selectedWarehouse: null,
        }
    },
    async mounted() {
        const page = Number(this.$route.params.page) || 1;
        await this.fetchData(page);
    },
    watch: {
        '$route.params.page'(newPage) {
            this.fetchData(Number(newPage));
        }
    },
    methods: {
        async selectRow(row) {
            this.selectedRow = row;
            await this.$axios.get(`medicine-stock/?medicine_id=${row.id}`).then((response) => {
                this.medicinesByExpirationDate = response.data;
            });
        },
        async select4Warehouse(row) {
            this.selected4Warehouse = row;
            console.log("selected4Warehouse:", row);
            await this.$axios.get(`warehouse-stock/?medicine_id=${row.id}`).then((response) => {
                this.medicinesByWarehouse = response.data;
            });
        },
        async fetchData(page = 1) {
            console.log('fetch medicines called');
            try {
                const response = await this.$axios.get(`medicine/?page=${page}`);
                console.log('response:', response.data);
                this.medicines = response.data.results;
                this.totalPages = Math.ceil(response.data.count / 10);
                this.currentPage = page;
                this.next = response.data.next;
                this.previous = response.data.previous;
            } catch (error) {
                Swal.fire('Hata!', `${error}`, 'error');
            }
        },
        async deleteMedicine(id) {
            const result = await Swal.fire({
                title: "Silmek istediğinizden emin misiniz?",
                text: "Bu işlem geri alınamaz!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "Hayır, iptal et"
            });

            if (result.isConfirmed) {
                try {
                    await this.$axios.delete(`medicine/${id}/`);
                    Swal.fire("Başarılı!", "Kayıt silindi.", "success");

                    this.fetchData();
                } catch (err) {
                    Swal.fire("Hata!", "Silme işlemi başarısız.", "error");
                    console.error(err);
                }
            }
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    }
}
</script>